module.exports = __webpack_public_path__ + "static/media/platinum-partner2.b38b5dfe.png";